import React from 'react';
import classNames from 'classnames';

export default function CardDescription({
    text,
    textTwoLine = false,
    className = 'CommonRatioCard__description',
}) {
    return (
        <div className={classNames(className, {'text-two-line': textTwoLine})}>
            {text}
        </div>
    );
}
